import React, { Suspense, useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './Pages/Home';
import Services from './Pages/Services';
import ContactUs from './Pages/ContactUs';
import AboutUs from './Pages/AboutUs';
import Faq from './Pages/Faq';
import TourismTours from './Pages/TourismTours';
import SendParcel from './Pages/SendParcel';
import News from './Pages/News';
import Login from './Pages/Login';
import './App.css';
import ForgetPassword from './Pages/ForgetPassword';
import NewPassword from './Pages/NewPassword';
import VerificationCode from './Pages/VerificationCode';
import NewsDetails from './Pages/NewsDetails';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import DeleteAccount from './Pages/DeleteAccount';
import TermsOfUse from './Pages/TermsOfUse';
import WithdrawBalance from './Pages/WithdrawBalance';
import PrebookingTrips from './Pages/PrebookingTrips';
import MyWallet from './Pages/MyWallet';
import Registration from './Pages/Registration';
import EditProfile from './Pages/EditProfile';
import MyPreferences from './Pages/MyPreferences';
import AddBalance from './Pages/AddBalance';
import AddBalanceForm from './Pages/AddBalanceForm';
import BookTour from './Pages/BookTour';
import RegisterTraveler from './Pages/RegisterTraveler';
import Verification from './Pages/Verification';
import Notifications from './Pages/Notifications';
import MyRates from './Pages/MyRates';
import CityTour from './Pages/CityTour'; 
import MyTrip from './Pages/MyTrip';
import MyReservation from './Pages/MyReservation';
import TripDetails from './Pages/TripDetails';
import ReservationDetails from './Pages/ReservationDetails';
import CityTourSingle from './Pages/CityTourSingle';
import PrivateRoute from './layout/PrivateRoute';
import { useDispatch, useSelector } from 'react-redux';
import CustomSpinner from './Components/CustomLoader/loader';
import PublicRoute from './layout/PublicRoute';
import { initializeAuth } from './actions/authAction';
import Logout from './Pages/logout';
import MySendParcels from './Pages/MySendParcels';
import ScrollToTop from './Pages/ScrollToTop';
import StandApp from './Pages/StandApp';

function App() {
  const {userDetails} = useSelector((state) => state.userStore);
  const {isLoading}= useSelector((state)=>state?.commonStore)
  const dispatch= useDispatch()

  useEffect(()=>{
    dispatch(initializeAuth())
  },[])

  return (
    <BrowserRouter>
      {isLoading && <CustomSpinner />}
      <Suspense fallback={<div>Loading...</div>}>
        <ScrollToTop />
        <Routes>

        <Route element={<PrivateRoute userData={userDetails} />}>
          <Route path="/prebooking-trips" element={<PrebookingTrips/>} /> 
        </Route>

        <Route path="/edit-profile" element={<EditProfile/>} />
        <Route path="/my-preferences" element={<MyPreferences/>} />
        <Route path="/add-balance" element={<AddBalance/>} />
        <Route path="/add-balance-form" element={<AddBalanceForm/>} />
        <Route path="/book-tour" element={<BookTour/>} />
        <Route path="/register-traveler" element={<RegisterTraveler/>} />
        <Route path="/my-wallet" element={<MyWallet/>} />
        <Route path="/withdraw-balance" element={<WithdrawBalance/>} />
        <Route path="/verifications" element={<Verification/>} />
        <Route path="/notifications" element={<Notifications/>} />
        <Route path="/my-rates" element={<MyRates/>} />
        <Route path="/my-trip" element={<MyTrip/>} />
        <Route path="/my-reservation" element={<MyReservation/>} />
        <Route path="/trip-details/:id" element={<TripDetails/>} />
        <Route path="/reservation-details/:id" element={<ReservationDetails/>} />
        <Route path="/logout" element={<Logout/>} />

        <Route element={<PublicRoute userData={userDetails} />}>
          <Route path="/login" element={<Login/>} />
          <Route path="/forget-password" element={<ForgetPassword/>} />
          <Route path="/new-password" element={<NewPassword/>} />
        </Route>

        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/tourism-tours" element={<TourismTours />} />
        <Route path="/send-parcel" element={<SendParcel />} />
        <Route path="/news" element={<News />} />
        <Route path="/verification" element={<VerificationCode />} />
        <Route path="/news-details/:id" element={<NewsDetails />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/registration" element={<Registration />} />
        <Route path="/city-tour" element={<CityTour />} />
        <Route path="/city-tour-single" element={<CityTourSingle />} />
        <Route path="/my-send-parcel" element={<MySendParcels/>} />
        <Route path="/stand-app" element={<StandApp/>} />

        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;